import React, { useState } from "react";
import { CircleAlert, Eye, EyeOff } from "lucide-react";
import "./InputValidation.css";

const InputField = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  required = false,
  error = "",
  icon: Icon,
  disabled = false,
  className = "",
  showPasswordToggle = false, // New prop
  labelTooltipText = "",
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const errorMessages = error 
  ? error.split(/[.,]\s*/).filter(msg => msg.trim().length > 0)
  : [];
  
  const hasMultipleErrors = errorMessages.length > 1;
  
  // Use showPassword state if showPasswordToggle is enabled
  const inputType = showPasswordToggle 
    ? (showPassword ? "text" : "password")
    : type;

  return (
    <div className={`input-field-wrapper ${className}`}>
      {label && (
        <label htmlFor={name} className="input-field-label">
          {Icon && <Icon size={13} />}
          <span>
            {label}
            {required && <span className="input-field-required">*</span>}
          </span>
          {labelTooltipText && (
            <span className="input-field-tooltip-wrapper" tabIndex={0}>
              <CircleAlert size={13} className="input-field-tooltip-icon" />
              <span className="input-field-tooltip-text" role="tooltip">
                {labelTooltipText}
              </span>
            </span>
          )}
        </label>
      )}
      
      <div className="input-field-container">
        <input
          type={inputType}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          className={`input-field ${error ? "input-field-error" : ""}`}
          {...props}
        />
        
        {/* Password toggle button */}
        {showPasswordToggle && (
          <button
            type="button"
            className="password-toggle-btn"
            onClick={() => setShowPassword(!showPassword)}
            tabIndex={-1}
          >
            {showPassword ? <Eye size={16} /> : <EyeOff size={16} />}
          </button>
        )}
      </div>
      
      {error && (
        hasMultipleErrors ? (
          <ul className="input-field-error-list">
            {errorMessages.map((msg, index) => (
              <li key={index} className="input-field-error-item">
                {msg}
              </li>
            ))}
          </ul>
        ) : (
          <div className="input-field-error-message">
            <span>{error}</span>
          </div>
        )
      )}
    </div>
  );
};

export default InputField;